<template>
  <div class="aikataulu">
    <div class="container defaultheading">
      <h1>Joulun aikataulu</h1> 
    </div>
    <div class="container">
      <p class="content independent">Tulevien tapahtumien päivämäärät ja tapahtuma-ajat löytyvät aina ajankohtaiseksi päivitettynä tältä sivulta.</p>
    </div>
    <Timetable />
  </div>
</template>

<script>
import Timetable from '@/components/Timetable.vue'

export default {
  name: "Aikataulu",
  components: {
    Timetable
  },
  data() {
    return {};
  }
};
</script>
<style scoped>
</style>